import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  isAdded: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    isDisplayOnEveryPage: false,
    layout: 'stacked',
    image: '',
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const footerSlice = createSlice({
  name: 'footer',
  initialState,
  reducers: {
    footerStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isAdded = true;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      // state.itemDesign = {
      //   shape: itemDesign.shape ?? 'round',
      //   border: itemDesign.border ?? 'none',
      //   borderColor: itemDesign.borderColor ?? '#000000',
      //   shadow: itemDesign.shadow ?? 'none',
      //   shadowColor: itemDesign.shadowColor ?? '#000000',
      // };
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        isDisplayOnEveryPage: blockContent.isDisplayOnEveryPage ?? false,
        layout: blockContent.layout ?? 'stacked',
        image: blockContent.image ?? '',
        items: blockContent.items ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
    },
    footerClear: () => initialState,

    footerUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    footerUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    footerUpdateIsAdded: (state, action) => {
      state.isAdded = action.payload;
    },
    footerUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { footerStore, footerClear, footerUpdateIsLoading, footerUpdateIsActive, footerUpdateIsAdded, footerUpdateBlockContent } = footerSlice.actions;

export const selectFooterIsLoading = (state) => state.footer.isLoading;

export const selectFooterId = (state) => state.footer.id;
export const selectFooterUID = (state) => state.footer.uid;
export const selectFooterIsAdded = (state) => state.footer.isAdded;
export const selectFooterIsDisplayOnEveryPage = (state) => state.footer.blockContent.isDisplayOnEveryPage;
export const selectFooterSID = (state) => state.footer.sid;

export const selectFooterBlockContent = (state) => state.footer.blockContent;
export const selectFooterLayout = (state) => state.footer.blockContent.layout;
export const selectFooterImage = (state) => state.footer.blockContent.image;
export const selectFooterBlockDesign = (state) => state.footer.blockDesign;
export const selectFooterSortItems = createSelector([selectFooterBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectFooterItemDesign = (state) => state.footer.itemDesign;
export const selectFooterContainerDesign = (state) => state.footer.containerDesign;

export default footerSlice.reducer;
